export default __webpack_public_path__ + "static/media/whatsApp.8e20e8a0.svg";